import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';
import { FieldId } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

interface PostalCodeInputProps {
    onChange: Function;
    value: any;
    isValid? : boolean;
}

const PostalCodeInput = ({
    onChange,
    value,
    isValid,
}: PostalCodeInputProps) => {

    return (
        <input
            className={`sid-text-input sid-text-input--required
                sid-l-full-width ${isValid ? '' : 'sid-text-input--error'}`}
            id="sid-postal-code"
            name="sid-postal-code"
            pattern="\d*"
            type="text"
            value={value}
            onChange={e => onChange(e.target.value)}
            ref={input => setRef('postalCode', input)}
        />
    );
};

PostalCodeInput.propTypes = {
    isValid: propTypes.bool,
    onChange: propTypes.func.isRequired,
    value: propTypes.string,
};
PostalCodeInput.defaultProps = {
    isValid: true,
    value: '',
};

export const PostalCodeInputComponent = PostalCodeInput;
